import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class KeyValueDTO  {
    _originalTypeClassName = "zERP.BO.KeyValueDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
KeyValueDTO.translate = translateService;
}
this.Display = null;
this.Value = null;
this.KeyValueDTOKey = null;
this._key = this.KeyValueDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Display:any;
Value:any;
private _KeyValueDTOKey:any;
get KeyValueDTOKey(): any {
    return this._KeyValueDTOKey;
  }
set KeyValueDTOKey(value: any) {
    this._KeyValueDTOKey = value;
    this._key = value;
  }

static Fill(display: any,value: any): any{let item = new Domain.KeyValueDTO();
item.Display = display;
item.Value = value;
return item;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.KeyValueDTOKey == null || $this.KeyValueDTOKey == 0;
            }


}